/*
 *
 * Package: `@dbh/radio-button-field-theme`.
 *
 */// @see `@dbh/checkbox/partials/CheckIcon.js`.
const size=24;const THEME_KEY_RADIO_BUTTON_FIELD="radioButtonField";const modifyRadioButtonFieldTheme=a=>{let{colors:{brandThird:b,white:c,greyLight:d,greyUltralight:e,blackLight:f},spacing:{sp3:g}}=a;return {[THEME_KEY_RADIO_BUTTON_FIELD]:{width:size,height:size,margin:"0 "+g+" 0 0",unchecked:{circleBackgroundColor:c,circleBorder:d,innerCircleFill:c,overColor:b},checked:{circleBackgroundColor:c,circleBorder:d,innerCircleFill:b,overColor:b},disabled:{circleBackgroundColor:e,circleBorder:d,innerCircleFill:e},disabledChecked:{circleBackgroundColor:e,circleBorder:d,innerCircleFill:f}}}};

export { THEME_KEY_RADIO_BUTTON_FIELD, modifyRadioButtonFieldTheme as default };
